import { ModuleWithProviders, NgModule, } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MaterialModule } from '../material/material.module'
import { DateFilterPipe } from './pipes/datefilter.pipe';



import {
  NbActionsModule,
  NbCardModule,
  NbLayoutModule,
  NbMenuModule,
  NbRouteTabsetModule,
  NbSearchModule,
  NbSidebarModule,
  NbTabsetModule,
  NbThemeModule,
  NbUserModule,
  NbCheckboxModule,
  NbPopoverModule,
  NbContextMenuModule,
  NbProgressBarModule,
  NbListModule,
  NbSpinnerModule,
  NbIconModule
} from '@nebular/theme';

import { NbEvaIconsModule } from '@nebular/eva-icons';

import {
  HeaderComponent,
  SearchInputComponent,
  ThemeSettingsComponent,

} from './components';

import {
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
} from './pipes';

import {
  SampleLayoutComponent,
} from './layouts';

import { DEFAULT_THEME } from './styles/theme.default';
import { COSMIC_THEME } from './styles/theme.cosmic';
import { CORPORATE_THEME } from './styles/theme.corporate';
import { FollowupComponent } from './components/followup/followup.component';


const BASE_MODULES = [CommonModule, FormsModule, ReactiveFormsModule];

const NB_MODULES = [
  NbCardModule,
  NbLayoutModule,
  NbTabsetModule,
  NbRouteTabsetModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbCheckboxModule,
  NbPopoverModule,
  NbContextMenuModule,
  NgbModule,
  NbProgressBarModule,
  NbListModule,
  NbSpinnerModule,
  NbEvaIconsModule,
  NbIconModule
];

const OTHER_MODULES = [
  MaterialModule,
]

const COMPONENTS = [
  HeaderComponent,
  SearchInputComponent,
  SampleLayoutComponent,
  ThemeSettingsComponent,
  FollowupComponent
];

const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
  DateFilterPipe
];

//name: 'corporate,default',
const NB_THEME_PROVIDERS = [
  ...NbThemeModule.forRoot(
    {
      name: 'default',
    },
    [DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME],
  ).providers,
  ...NbSidebarModule.forRoot().providers,
  ...NbMenuModule.forRoot().providers,
  DatePipe
];

@NgModule({
  imports: [...BASE_MODULES, ...NB_MODULES, ...OTHER_MODULES],
  exports: [...BASE_MODULES, ...NB_MODULES, ...COMPONENTS, ...PIPES, ...OTHER_MODULES],
  declarations: [...COMPONENTS, ...PIPES, ThemeSettingsComponent]
})

export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [...NB_THEME_PROVIDERS],
    };
  }
}
